import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { ActivatedRoute } from '@angular/router';
import { User } from 'src/app/core/interfaces/auth/user';
import { Zone } from 'src/app/core/interfaces/zones/zone';
import { ApiService } from 'src/app/core/services/api/api.service';
import { DataService } from 'src/app/core/services/data/data.service';

@Component({
  selector: 'app-service-calendar-filters',
  templateUrl: './service-calendar-filters.component.html',
  styleUrls: ['./service-calendar-filters.component.scss'],
})
export class ServiceCalendarFiltersComponent implements OnInit {
  zones: Zone[];
  selectedZone: string;

  techArray: User[];
  selectedTech: User;

  currentPath: string;

  @Output() filterAppointments = new EventEmitter<string>();

  constructor(
    private data: DataService,
    private apiService: ApiService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.data.currentPath.subscribe((path) => {
      this.currentPath = path;
    });
    // api call to get zones
    this.apiService.getAllZones().subscribe((zones) => {
      this.zones = zones;
    });
  }

  getServiceTechsByZone(zoneId: number) {
    this.apiService.getServiceTechByZone(zoneId).subscribe((techs) => {
      this.techArray = techs;
    });
  }

  selectZone(event: MatSelectChange) {
    this.data.changeZone(event.value);
  }

  selectTech(event: MatSelectChange) {
    this.data.changeTech(event.value);
  }

  ngOnDestroy(): void {
    this.data.changeZone(null);
  }
}
